import { GST_AU_RATE } from 'Common/config/gstRate';

export function getExclGST(amount) {
  return (amount * GST_AU_RATE) / 11;
}

export function getTaxPrice(amount, isIncludeGST) {
  return isIncludeGST ? amount : (amount * 11) / GST_AU_RATE;
}
